import { barkApi, bugsnagClientNotify } from "@bark/bark-core";

const getRecaptchaToken = () => {
    return new Promise((resolve, reject) => {
        try {
            const keyId = $('#ml-recaptcha-script').data('key');
            grecaptcha.enterprise.ready(async () => {
                try {
                    const token = await grecaptcha.enterprise.execute(keyId, { action: 'reset_password' });
                    resolve(token);
                } catch (e) {
                    reject()
                }
            });
        } catch (e) {
            reject()
        }
    })
}

export const forgotPasswordRequest = async (email) => {
    const captchaToken = await getRecaptchaToken();
    return new Promise(resolve => {
        barkApi(
            `reset-password`,
            {
                email,
                captchaToken,
                platform: 'web',
            },
            (res) => {
                resolve(res);
            },
            (error) => {
                if (error?.status === 422) {
                    resolve(false);
                } else {
                    console.error(error);
                    bugsnagClientNotify('forgotPasswordRequest not successful', error);
                    resolve(false);
                }
            },
            'POST'
        );
    })
};
